import TitleInput from './inputs/title';
import BodyInput from './inputs/body';
import DescriptionInput from './inputs/description';
import { Spinner } from '../../../components/ui';
import { useUserGeneratedContent } from '../../../models/user-generated-contents/context';
import './form.scss';

const UserGeneratedContentFormFields = () => {
  const { isLoading } = useUserGeneratedContent();

  if (isLoading) {
    return (
      <div className="post-form">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="post-form">
      <TitleInput />
      <DescriptionInput />
      <hr className="post-form__divider" />
      <BodyInput />
    </div>
  );
};

export default UserGeneratedContentFormFields;
